module.exports = __webpack_public_path__ + "img/pikabu-logo-new.68c1d9c6.svg";